<template>
  <img class="image__eruvaka--100" src="@/assets/eruvaka_icon.png" />
</template>

<script>
export default {};
</script>

<style lang="scss">
.image__eruvaka--100 {
  width: 100px;
  height: 100px;
  margin-bottom: 10px;
}
</style>
